import React, { Component } from 'react'

export class Summary extends Component {
  

       render() {
       
        return (
           
            <div>
                <header className="w3-container w3-center">
                    <h6><b>Welcome to Project!!!...</b></h6>
                 
                    <div className="w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom" >
                            <header className="w3-container w3-light-grey ">
                            <h6><b>"Design and Development of Hybrid Renewable
                                    Energy Microgrid with Value Chain Applications
                                    for Agriculture Dairy Farm"</b></h6>
                            </header>
                            <div className="w3-container w3-row w3-padding">
                                
                                    <div className="w3-small w3-text-grey">Supported By</div>
                                    <div className="w3-text-green w3-large"><b> DST, Govt. Of India</b></div>
                               
                         
                            </div>            
                        </div>

                </header>

                <div className=" w3-row-padding w3-margin-bottom">
                    <div className="w3-half">
                        <div className="w3-margin-bottom">
                        <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading">Vision</th>
                                <th className="w3-center w3-large my-table-heading">It's Challenges</th>
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Efficient Renewable Energy Integration.</td>
                                <td>Reduce conversion loss from DC power to AC power due to increase of DC load such as electric vehicle.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Increase in net land yield of farmers.</td>
                                <td>Due to the climate change the average productivity of the land is reduces. So a solution is needed which will help the farmers for getting an steady income in various weather conditions.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Electric power for irrigation and value chain.</td>
                                <td>Generating electric power efficiently and transmitting to the consumer end effectively</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Contribute to the Government’s immediate targets of Installing 100 GW of solar plants by 2022.</td>
                                <td>Stress on land resources, unavailability of suitable rooftop space, excessive cost of grid infrastructure required to evacuate the power from MW size plants located at remote barren lands.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span> Contribute to the Government’s immediate targets of doubling the income of farmers by 2022.</td>
                                <td>Unavailability of reliable and good quality electricity resulting in lack of value chain, excessive dependence of Diesel which is expansive and not environment friendly, vagaries of weather often spoil the crops, leaving the land useless for long period of time.</td>
                            </tr>
                         
                           

                    
                            </tbody>
                        </table>            

                        </div>
                        
                       
                    </div>
                    <div className="w3-half">
                    <div className="w3-margin-bottom">
                        <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan='2'>Objectives</th>
                                
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>A hybrid AC/DC Smart Microgrid for integration of diverse renewable energy resources with utility grid and rational end use of renewable energy in the microgrid.</td>
                               
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>A Solar-Agriculture Farm based multiple land-use to facilitate agriculture as well as solar farming on the same land, thereby, increasing net yield of the land and increasing farmer’s income.</td>
                                
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Development of solar powered value chain machinery for agriculture and dairying for empowering farmers.</td>
                                
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Effective utilization of Electrical Energy generated from agriculture and dairy waste.</td>
     
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Development of Specialized laboratory for study and planning of such  Microgrids.</td>

                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Techno-economic analysis from the demonstration project and its projection to MW sized power plants in the vicinity of the load center vis-à-vis a conventional plant in barren land, away from the load center. Development of alternative business models for farmers of different financial capabilities.</td>

                            </tr>
                            


                    
                            </tbody>
                        </table>            

                        </div>
                    
                    </div>


                </div>
                <div className=" w3-row-padding w3-margin">
                        <div className="w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom">
                            <header className="w3-container w3-light-grey ">
                            <h6><b>DIFFERENT STAGES</b></h6>
                            </header>
                            <div className="w3-row">
                            <img className='my-stage' src='./images/stages.png' alt='stages'/>
                            </div>            
                        </div>
                        {/* <div className="w3-card-2 w3-white w3-round-large w3-center w3-margin-bottom">
                            <header className="w3-container w3-light-grey ">
                            <h6><b>DIFFERENT STAGES</b></h6>
                            </header>
                            <div className="w3-container w3-row w3-padding">
                                <div className="w3-col s6 w3-border-right">
                                    <div className="w3-small w3-text-grey">Daily</div>
                                    <div className="w3-text-green w3-large"><b>843 MT</b></div>
                                </div>
                                <div className="w3-col s6">
                                    <div className="w3-small w3-text-grey">Monthly</div>
                                    <div className="w3-text-green w3-large"><b>843 MT</b></div>
                                </div>
                            </div>            
                        </div> */}
                        {/* <div className="w3-card-2 w3-white w3-round-large w3-center">
                            <header className="w3-container w3-light-grey ">
                            <h5><b>Outcome</b></h5>
                            </header>
                            <div className="w3-container w3-row w3-padding">
                                    <div className="w3-small w3-text-grey">Total</div>
                                    <div className="w3-text-green w3-large"><b>843 MW</b></div>
                            </div>   
                            <div className="w3-container w3-row w3-padding">
                                <div className="w3-col s6 w3-border-right">
                                    <div className="w3-small w3-text-grey">4 X 250MW (STAGE - I)</div>
                                    <div className="w3-text-yellow"><b>843 MW</b></div>
                                </div>
                                <div className="w3-col s6">
                                    <div className="w3-small w3-text-grey">4 X 250MW (STAGE - II)</div>
                                    <div className="w3-text-yellow"><b>843 MW</b></div>
                                </div>
                            </div>            
                        </div> */}
                
                </div>

                <div className=" w3-row-padding w3-margin-bottom">
                    <div className="w3-half">
                
                        
                        
                        <div className="w3-margin-bottom">
                        <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan="3">Outcome</th>
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Solar agriculture farm with multiple land use.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>A Hybrid AC/DC Microgrid integrating diverse RES with utility grid.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Solar Powered value chain machinery for agriculture and dairying.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Establishment of Hybrid Microgrid test system.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Flexible Lab for Hybrid Microgrid.</td>
                            </tr>
                            <tr>
                                <td><span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Utilization of bio-gas generated from agriculture and dairy waste for electrical energy production and its integration.</td>
                            </tr>
                           

                    
                            </tbody>
                        </table>            

                        </div>
                    </div>
                    <div className="w3-half">
                   
                    <div className="w3-margin-bottom">
                        <table className="w3-table-all"  >
                            <thead>
                            <tr  className=" w3-bottombar w3-border-blue">
                                <th className="w3-center w3-large my-table-heading" colSpan="3">Target Beneficiaries</th>
                                
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Farmers</td>
                            </tr>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Rural population</td>
                            </tr>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Dairy Farms</td>
                            </tr>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Electric Energy Consumers</td>
                            </tr>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Agriculture Machine Industries</td>
                            </tr>
                            <tr>
                                <td> <span className='w3-green w3-circle w3-margin-right'><i className='fa fa-check-circle w3-large'></i></span>Food Processing Industries</td>
                            </tr>

                    
                            </tbody>
                        </table>            

                        </div>
                    </div>


                </div>



                
            </div>
        )
    
    }
}



export default Summary
